import { render, staticRenderFns } from "./myPopupForSms.vue?vue&type=template&id=0148e8e1&scoped=true"
import script from "./myPopupForSms.vue?vue&type=script&lang=js"
export * from "./myPopupForSms.vue?vue&type=script&lang=js"
import style0 from "./myPopupForSms.vue?vue&type=style&index=0&id=0148e8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148e8e1",
  null
  
)

export default component.exports